import { HIDE_ON_HOVER, SHOW_ON_HOVER } from "lib/core_components/ShowOnHover";
import { pluralise } from "../../../../lib/utils";
import EntityTag from "../../EntityTag";
import { SaveListButton } from "./SaveListButton";
import { useSaveListDrawer } from "./SaveListDrawerProvider";
import { ListEntities } from "./SaveToLists";

const getEntityTagTitle = (savedListNames: string[], savedCount: number) => {
  if (savedListNames.length > 1) {
    return `Saved to ${pluralise(savedListNames.length, "list")}`;
  }

  if (savedListNames.length === 1) {
    return `Saved to ${savedListNames[0]}`;
  }

  return `Saved to ${pluralise(savedCount, "list")}`;
};
type DisplayType = "showSavedLists" | "button";

type InlineSaveToListButtonProps = {
  entityType: ListEntities;
  entityIds: string[];
  displayType: DisplayType;
  savedListNames?: string[];
  savedCount?: number;
};

/**
 * Changes display depending on how many lists the entity has been saved to.
 * This button needs to be used within the context of @see SaveListDrawerProvider.
 */
export function InlineSaveListButton({
  displayType,
  savedListNames = [],
  savedCount: savedCountOverride,
  entityType,
  entityIds,
}: InlineSaveToListButtonProps) {
  const { openListDrawer } = useSaveListDrawer();

  const savedCount = savedCountOverride ?? savedListNames.length;

  const saveButton = (
    <SaveListButton
      entityType={entityType}
      entityIds={entityIds}
      trackingData={{ "Context source": "In row" }}
      buttonProps={{
        buttonType: "secondary",
        icon: {
          icon: "bookmark",
          fill: savedCount > 0 ? "sysPrimaryDefault" : "transparent",
        },
      }}
      onShowDrawer={() =>
        openListDrawer({
          entityType,
          entityIds,
        })
      }
    />
  );

  if (savedCount === 0) {
    return <span className={SHOW_ON_HOVER}>{saveButton}</span>;
  }

  if (displayType === "showSavedLists") {
    const title = getEntityTagTitle(savedListNames, savedCount);

    return (
      <>
        <span className={HIDE_ON_HOVER}>
          <EntityTag title={title} icon="bookmark" />
        </span>
        <span className={SHOW_ON_HOVER}>{saveButton}</span>
      </>
    );
  }

  return saveButton;
}
